import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const shippingTicketRoutes: RouteObject[] = [
  {
    path: '/shipping-ticket/outbound',
    element: lazyElement(() => import('./OutboundList')),
    handle: {
      documentTitle: 'Outbound Tickets',
      crumb: () => ({ label: 'Outbound Tickets', to: '/shipping-ticket/outbound' }),
    },
  },
  {
    path: '/shipping-ticket/outbound/create/:facilityId',
    element: lazyElement(() => import('./OutboundCreate')),
    handle: {
      documentTitle: 'Create Outbound Ticket',
      crumb: () => ({ label: 'Create Outbound Ticket' }),
    },
  },
  {
    path: '/shipping-ticket/outbound/view/:id',
    element: lazyElement(() => import('./OutboundView')),
    handle: { crumb: () => ({ label: 'Outbound Ticket' }) },
  },
  {
    path: '/shipping-ticket/outbound/print/:id',
    element: lazyElement(() => import('./OutboundPrint')),
    handle: { crumb: () => ({ label: 'Print' }) },
  },
  {
    path: '/shipping-ticket/inbound',
    element: lazyElement(() => import('./InboundList')),
    handle: {
      documentTitle: 'Inbound Tickets',
      crumb: () => ({ label: 'Inbound Tickets', to: '/shipping-ticket/inbound' }),
    },
  },
  {
    path: '/shipping-ticket/inbound/create/:facilityId',
    element: lazyElement(() => import('./InboundCreate')),
    handle: {
      documentTitle: 'Create Return Ticket',
      crumb: () => ({ label: 'Create Return Ticket' }),
    },
  },
  {
    path: '/shipping-ticket/inbound/view/:id',
    element: lazyElement(() => import('./InboundView')),
    handle: { crumb: () => ({ label: 'Inbound Ticket' }) },
  },
  {
    path: '/shipping-ticket/inbound/print/:id',
    element: lazyElement(() => import('./InboundPrint')),
    handle: { crumb: () => ({ label: 'Print' }) },
  },
];

export default shippingTicketRoutes;
